import { render } from "./TestimonialSite.vue?vue&type=template&id=45643e34"
import script from "./TestimonialSite.vue?vue&type=script&lang=js"
export * from "./TestimonialSite.vue?vue&type=script&lang=js"

import "./TestimonialSite.vue?vue&type=style&index=0&id=45643e34&lang=css"

import exportComponent from "G:\\BWD\\BWD-NEW-05-04-2024\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__